export default __webpack_public_path__ + "static/media/kaapse.4e0e44be.png";